import React from "react";
import { Button, Space, Typography } from "antd";
import { Link } from "react-router-dom";
import StakedIcon from "./staked-icon.svg";
import { RiskModalProps } from "@funds/pages/MyFunds/utils";
import { AGREEMENT_TYPES } from "@services/UserAgreements.service";
import { FUNDS_STAKING_FORM } from "@funds/config";

import * as style from "../../../../StakingPageStyle.module.scss"
import * as emptyStateStyles from "./EmptyStateStyles.module.scss";

type Props = {
  shouldOpenRiskWarningModal?: boolean;
  isUk?: boolean;
  handleOpenRiskWarningModal: (props: RiskModalProps) => void;
};

const EmptyState = ({
  shouldOpenRiskWarningModal,
  isUk,
  handleOpenRiskWarningModal,
}: Props) => {
  const basePath = `${location.pathname.split("/funds")[0]}/funds`;

  return (
    <Space
      direction="vertical"
      align="center"
      className={style.section}
      style={{ display: "flex" }}
    >
      <Typography.Title level={1} style={{ textAlign: "center" }}>
        Unlock Your Weekly ETH Income
      </Typography.Title>
      <Typography.Title
        level={5}
        style={{ textAlign: "center", marginTop: "-20px" }}
      >
        (& Convert Your Income to Bitcoin If You’re A Bitcoin Maxi)
      </Typography.Title>
      <Space direction="horizontal" style={{ textAlign: "center" }}>
        <Typography.Paragraph>
          {isUk
            ? "Maximise your ETH earnings every Monday with BF's staking process. Start staking now and receive ETH income by clicking the button below. "
            : "Maximize your ETH earnings effortlessly every Monday with BF's seamless staking process. Start staking now and receive ETH income by clicking the button below."}
        </Typography.Paragraph>
      </Space>
      <Space size={1} direction="vertical" style={{ textAlign: "center" }}>
        <StakedIcon />
        <br />
        <Link
          className={emptyStateStyles.button}
          onClick={(e) => {
            if (shouldOpenRiskWarningModal) {
              e.preventDefault();
              handleOpenRiskWarningModal({
                agreementType: AGREEMENT_TYPES.ETH_STAKING,
                redirectionPath: `${basePath}/${FUNDS_STAKING_FORM}`,
              });
            }
          }}
          to={`staking`}
        >
          <Button type="primary">Stake ETH now</Button>
        </Link>
      </Space>
    </Space>
  );
};

export default EmptyState;
